<template>
  <v-menu bottom left offset-y :nudge-bottom="10" transition="scale-transition">
    <template v-slot:activator="{ on }">
      <v-btn icon large text v-on="on">
        <v-icon dark>translate</v-icon>
      </v-btn>
    </template>
    <v-list class="pa-0">
      <v-list-item
        v-for="(item, index) in languages"
        :key="index"
        @click="handleSetLanguage(item.value)"
        :disabled="item.value === language"
      >
        <v-list-item-action>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "LangSelect",
  data: () => ({
    languages: [
      {
        name: "English",
        isoName: "English",
        value: "en"
      },
      {
        name: "日本語 (にほんご)",
        isoName: "Japanese",
        value: "ja"
      },
      {
        name: "بهاس ملايو‎",
        isoName: "Malay",
        value: "ms"
      },
      {
        name: "Tiếng Việt",
        isoName: "Vietnamese",
        value: "vi"
      }
    ]
  }),
  computed: {
    language() {
      return this.$store.getters.language;
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch("setLanguage", lang);
    }
  }
};
</script>

<style scoped></style>
